import React from 'react';
import Base from './Base';

export default class ObligationSelectorModal extends Base {
    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            users: [],
            selectedTemplateIds: [],
            fiscalYear: props.fiscalYear || 1405,
            assignedToUserId: '',
            supervisorUserId: '',
            loading: true,
            generating: false
        };
    }

    componentDidMount() {
        // دریافت قالب‌ها
        this.httpPost('api/v1/legalobligation/templates/list', {})
            .then(data => this.setState({ templates: data.templates || [] }))
            .catch(() => { });
        // دریافت کاربران
        this.httpPost('api/v1/user/list', { page: 1, count: 200, phrase: '', filters: {} })
            .then(data => this.setState({ users: data.records || [] }))
            .catch(() => { });
        this.setState({ loading: false });
    }

    toggleTemplate(id) {
        const arr = [...this.state.selectedTemplateIds];
        const idx = arr.indexOf(id);
        if (idx > -1) arr.splice(idx, 1);
        else arr.push(id);
        this.setState({ selectedTemplateIds: arr });
    }

    generate() {
        const { selectedTemplateIds, fiscalYear, assignedToUserId, supervisorUserId } = this.state;
        if (selectedTemplateIds.length === 0) {
            this.showErorrMessage('حداقل یک قالب انتخاب کنید');
            return;
        }
        this.setState({ generating: true });
        this.httpPost('api/v1/legalobligation/generate', {
            contractIds: [this.props.contractId],
            templateIds: selectedTemplateIds,
            fiscalYear,
            assignedToUserId: assignedToUserId || null,
            supervisorUserId: supervisorUserId || null
        }).then(data => {
            this.setState({ generating: false });
            if (data.status === 1) {
                this.showSuccessMessage(data.message);
                this.props.onSaved();
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    render() {
        const { show, onClose } = this.props;
        const { templates, users, selectedTemplateIds, fiscalYear, assignedToUserId, supervisorUserId, generating } = this.state;
        if (!show) return null;

        return (
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">افزودن تکالیف به قرارداد</h5>
                            <button type="button" className="close" onClick={onClose}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">سال مالی</label>
                                    <input type="number" className="form-control" value={fiscalYear}
                                        onChange={e => this.setState({ fiscalYear: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">مجری</label>
                                    <select className="form-select" value={assignedToUserId}
                                        onChange={e => this.setState({ assignedToUserId: e.target.value })}>
                                        <option value="">-- پیش‌فرض (مدیر پرونده) --</option>
                                        {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">سرپرست</label>
                                    <select className="form-select" value={supervisorUserId}
                                        onChange={e => this.setState({ supervisorUserId: e.target.value })}>
                                        <option value="">-- پیش‌فرض (سرپرست پرونده) --</option>
                                        {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                    </select>
                                </div>
                            </div>
                            <hr />
                            <h6>قالب‌های تکلیف</h6>
                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {templates.map(t => (
                                    <div className="custom-control custom-checkbox" key={t.id}>
                                        <input type="checkbox" className="custom-control-input" id={`t${t.id}`}
                                            checked={selectedTemplateIds.includes(t.id)}
                                            onChange={() => this.toggleTemplate(t.id)} />
                                        <label className="custom-control-label" htmlFor={`t${t.id}`}>
                                            {t.title} ({t.periodType === 'Monthly' ? 'ماهانه' :
                                                t.periodType === 'Quarterly' ? 'فصلی' :
                                                    t.periodType === 'Yearly' ? 'سالانه' : 'روزانه'})
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={() => this.generate()} disabled={generating}>
                                {generating ? 'در حال تولید...' : 'تولید'}
                            </button>
                            <button className="btn btn-secondary" onClick={onClose}>انصراف</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}